<script setup>
import { computed, getCurrentInstance, onBeforeMount, ref, watch } from 'vue';

const props = defineProps({
    formId: String,
    currentData: Object,
    field: Object,
});

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// Local state initialized from currentData
const value = ref(props.currentData[props.field.name]);

// Computed
const tableName = computed(() => {
    return store.state[props.formId].tableName;
});

// Watcher to sync local ref back to currentData object
watch(value, (newValue) => {
    props.currentData[props.field.name] = newValue === '1' ? 1 : 0;
});

// Lifecycle: Set default value if required before mounting
onBeforeMount(() => {
    store.dispatch(props.formId + '/setDefaultValue', {
        name: props.field.name,
        value: props.field.checked || 0
    });
});

// Logic-heavy click handler
const onClick = (e) => {
    const sensitiveFields = [
        'showMetadata',
        'showTags',
        'showScripts',
        'useArchive',
        'showDisplayOrder',
        'showScheduling',
        'showStatus'
    ];

    if (
        tableName.value === 'modulecomponents' &&
        sensitiveFields.includes(props.field.name) &&
        parseInt(props.currentData[props.field.name])
    ) {
        store.dispatch('modals/show', {
            componentName: 'ConfirmModal',
            obj: {
                modalTitle: 'Are you sure?',
                modalBody: `
                    <p class="alert alert-danger">
                        This action will result in loss of data.
                    </p>
                    <p>
                        This action <strong>cannot</strong> be undone.
                    </p>
                `,
                onConfirm: () => {
                    value.value = 0;
                }
            }
        });

        e.preventDefault();
    }
};
</script>

<template>
    <input
        v-if="field.readonly"
        v-model="value"
        disabled
        false-value="0"
        true-value="1"
        type="checkbox"
        class="form-check-input"
    >
    <input
        v-else
        :id="field.id"
        v-model="value"
        :disabled="field.disabled"
        :name="field.name"
        :required="field.required"
        false-value="0"
        true-value="1"
        type="checkbox"
        @click="onClick"
        class="form-check-input"
    >
</template>